import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/no-array-index-key */
import type { CalendarDate } from '@newfront-insurance/string-formatters';
import type { JSX } from 'react';
import { DayCell, EmptyDayCell } from './day';
import type { CalendarHook } from '../hooks/calendar';
const labels = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
interface Props {
  onClick: (date: CalendarDate) => unknown;
  calendarHook: CalendarHook;
  validate?: (date: CalendarDate) => boolean;
  selectedDate?: CalendarDate;
}
export default function CalendarMonth(props) {
  const $ = _c(17);
  const {
    calendarHook,
    onClick,
    validate,
    selectedDate
  } = props;
  const {
    calendar
  } = calendarHook;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <thead><tr>{labels.map(_temp)}</tr></thead>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== calendar || $[2] !== calendarHook.month || $[3] !== onClick || $[4] !== selectedDate || $[5] !== validate) {
    let t2;
    if ($[7] !== calendarHook.month || $[8] !== onClick || $[9] !== selectedDate || $[10] !== validate) {
      t2 = (week, index) => <tr key={index}>{week.map(calendarDay => {
          const isValid = validate ? validate(calendarDay) : true;
          const isSelected = selectedDate && calendarDay.isSameDate(selectedDate);
          const isCurrentMonth = calendarDay.getMonth() === calendarHook.month;
          return <DayCell day={calendarDay} isSelected={isSelected} isDisabled={!isValid} isCurrentMonth={isCurrentMonth} key={calendarDay.toString()} onClick={() => {
            onClick(calendarDay);
          }} />;
        })}</tr>;
      $[7] = calendarHook.month;
      $[8] = onClick;
      $[9] = selectedDate;
      $[10] = validate;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t1 = calendar.map(t2);
    $[1] = calendar;
    $[2] = calendarHook.month;
    $[3] = onClick;
    $[4] = selectedDate;
    $[5] = validate;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[12] !== calendar.length) {
    t2 = calendar.length === 5 && <tr>{[...Array(7)].map(_temp2)}</tr>;
    $[12] = calendar.length;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t1 || $[15] !== t2) {
    t3 = <div><table className="w-full border-collapse" cellSpacing="0" cellPadding="0">{t0}<tbody>{t1}{t2}</tbody></table></div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}
function _temp2(_, index_0) {
  return <EmptyDayCell key={`empty-day-${index_0}`} />;
}
function _temp(label) {
  return <th className="h-[30px] pt-[5px]" key={label}><span className="text-base font-semibold">{label}</span></th>;
}